// extracted by mini-css-extract-plugin
export default {"margem_objetiva_fallback":"MargemObjetivaFallback_margem_objetiva_fallback__72sop"};